module.exports = __webpack_public_path__ + "img/enging_room_pic02.cf57c12b.png";